import { Pagination } from "../../../../modules/pages/interview-summary/pagination";
import { Filters } from "../../../components/filters/models/filters";
import { INetwork, Network } from "./network";
import { IPeriodAndSurveyType, PeriodAndSurveyType } from "./periodAndSurveyType";
import { IProduct, Product } from "./product";
import { IQuestion, Question } from "./question";
import { MatomoService } from '../../matomo.service';


export interface IPayload {
  network: INetwork,
  product: IProduct,
  periodAndSurveyType: IPeriodAndSurveyType,
  question: IQuestion,
  pagination?: Pagination
}

export class Payload implements IPayload {
  network: INetwork = new Network();
  product: IProduct = new Product();
  periodAndSurveyType: IPeriodAndSurveyType =  new PeriodAndSurveyType();
  question: IQuestion = new Question();

  private constructor(filters?: Filters) {
    if(filters){
      this.network =  new Network(filters.network);
      this.product = new Product(filters.product);
      this.periodAndSurveyType = new PeriodAndSurveyType(filters.periodAndSurveyType);
    }
  }

  static create(filters: Filters | undefined, matomoService: MatomoService | undefined): Payload {
    //if(!!filters && !!matomoService) matomoService.trackEvent('Filter', 'created', JSON.stringify(filters));
    return new Payload(filters);
  }
}

